import axiosPost from "./axiosPost";

export const RNHTituloGet = async (credentials, data) => {
    const body = {
        service: "RNHTituloGet",
        params: {
            rnhTituloId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
